
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/copies",
      function () {
        return require("private-next-pages/corporatiu/copies/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/copies"])
      });
    }
  